import { useHubspotForm } from "next-hubspot";
import { Box, Text, Spinner } from "@chakra-ui/react";
import { sendGTMEvent } from "@next/third-parties/google";

const JoinMailingForm = () => {
  const { loaded, error, formCreated } = useHubspotForm({
    region: "na1",
    portalId: "43951417",
    formId: "daa2c55b-7a63-4eff-bd96-685f3211ce42",
    target: "#join-mailing-form",
    onFormSubmitted: () => {
      if (process.env.VERCEL_ENV === "production") {
        sendGTMEvent({
          event: "gtm.formSubmit",
          formId: "join-mailing-form",
        });
      }
    },
  });
  if (error) {
    return <Text>Error</Text>;
  }

  if (!loaded) {
    return <Spinner />;
  }

  if (formCreated) {
    return <Box id="join-mailing-form" />;
  }

  return <Text>Form not yet created.</Text>;
};

export default JoinMailingForm;
